import { TApplicationState } from '../../types/redux';

export function getDiscountMortgage(state: TApplicationState): boolean {
  return Boolean(state.newbuilding.hasDiscountMortgage);
}
